// ----------------------------------------------------------------------------
// Application JavaScript
// ----------------------------------------------------------------------------
//
// All scripts are loaded to the project through this master script sheet,
// which bundles our code via Browserify.
//
// Includes are listed alphabetically for easiest identification.
//
// ----------------------------------------------------------------------------

// ============================================================================
// Base Variable Definitions
// ============================================================================
var $             = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var addtocalendar = require('addtocalendar');


// ============================================================================
// Load Scripts
// ============================================================================

// Execute High-priority Scripts
require('./vendor/component-library/base/modernizr/modernizr-tests');
$(document).on('ready', require('./vendor/component-library/base/lazysizes/lazysizes'));


// ============================================================================
// Component Scripts
// ============================================================================

// Base
// -------------------------------------
$(document).on('ready', require('./vendor/component-library/base/scroll-to/scroll-to'));

// Form Fields
$(document).on('ready', require('./vendor/component-library/base/forms/fields/password'));
$(document).on('ready', require('./vendor/component-library/base/forms/fields/submit'));
$(document).on('ready', require('./vendor/component-library/base/forms/fields/image-radio'));
$(document).on('ready', require('./vendor/component-library/base/forms/fields/date-picker/date-picker'));

// Form Validation
$(document).on('ready', require('./vendor/component-library/base/forms/validation/validate'));
$(document).on('ready', require('./vendor/component-library/base/forms/validation/validate-submit-ajax'));
$(document).on('ready', require('./vendor/component-library/base/forms/validation/validate-submit-native'));
$(document).on('ready', require('./vendor/component-library/base/forms/validation/validate-submit-mailchimp'));


// Containers
// -------------------------------------
$(document).on('ready', require('./vendor/component-library/components/containers/accordion/accordion'));
$(document).on('ready', require('./vendor/component-library/components/containers/carousel/carousel'));
$(document).on('ready', require('./vendor/component-library/components/containers/masonry-grid/masonry-grid'));
$(document).on('ready', require('./vendor/component-library/components/containers/tabs/tabs'));


// Content
// -------------------------------------


// Site Elements
// -------------------------------------
$(document).on('ready', require('./vendor/component-library/components/site-elements/jump-to/jump-to'));


// Template Scripts
// -------------------------------------



// ============================================================================
// Project Specific Scripts
// ============================================================================

// Base
// -------------------------------------
$(document).on('ready', require('./base/forms/ux'));


// Containers
// -------------------------------------
$(document).on('ready', require('./components/containers/carousel/carousel--card'));
$(document).on('ready', require('./components/containers/carousel/carousel--gallery'));
$(document).on('ready', require('./components/containers/isotope-layout/isotope-layout'));


// Content
// -------------------------------------
$(document).on('ready', require('./components/content/card/card'));
$(document).on('ready', require('./components/content/item-list/item-list'));


// Site Elements
// -------------------------------------
$(document).on('ready', require('./components/site-elements/announcement-bar/announcement-bar'));
$(document).on('ready', require('./components/site-elements/events-feed/events-feed'));
$(document).on('ready', require('./components/site-elements/calendar/calendar'));
$(document).on('ready', require('./components/site-elements/search/search'));
$(document).on('ready', require('./components/site-elements/tooltip/tooltip'));


// Template Scripts
// -------------------------------------
$(document).on('ready', require('./templates/partials/site-header/site-navigation/site-navigation'));
